import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";
import {camStudyService} from "@/core/service/camstudy/room.camstudy.service";

class RoomCamstudyPersonalApi extends BaseApi {
    constructor() {
        super();
        Room.CamstudyPersonal = this;
        Room.addEventListeners(this._CoreEvents, this);
        this.getPersonalSetting().then((res) => {
            const personalSetting = res;
            Room.addRoomData({roomCamstudyPersonal: {personalSetting}})
        });
    }

    async getPersonalSetting() {
        let personalSetting = Room.getRoomData().roomCamstudyPersonal?.personalSetting;
        const coverFace = localStorage.getItem('coverFace') ?? 'off';
        if(personalSetting) {
            return {...Room.getRoomData().roomCamstudyPersonal.personalSetting, coverFace};
        }

        return {...(await camStudyService.getPersonalSetting()).data, coverFace};
    }

    async modifyPersonalSetting(data) {
        const personalSetting = (await camStudyService.modifyPersonalSetting(data)).data;
        if(Object.hasOwn(data, 'coverFace')) {
            localStorage.setItem('coverFace', data.coverFace);
        }
        Room.getRoomData().roomCamstudyPersonal.personalSetting = personalSetting;
        Room.trigger('room_changePersonalSetting')
        return personalSetting
    }

    _CoreEvents = {
        room_call_loadLocalStream: async function(e) {
            const personalSetting = await this.getPersonalSetting();
            await Room.CamstudyPersonal.modifyPersonalSetting(personalSetting);
        },
        // room_changePersonalSetting: async function(e) {
        //     this.filter();
        // }
    }
}

export const CamstudyPersonal = new RoomCamstudyPersonalApi();